var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "layout-header" }, [
    _c(
      "div",
      {
        staticClass: "layout-header-editable",
        class: { "is-highlight": _vm.highlight }
      },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "layout-header-shadow" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }